import script from "./PhotoGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&setup=true&lang=js"

import "./PhotoGallery.vue?vue&type=style&index=0&id=8d94f5be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d94f5be"]])

export default __exports__